import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import * as Moment from "moment";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { readProfileByDomainWidget } from "../../store/profile/thunkAction";
import { readProfileAppearanceByProfileId } from "../../store/profile-appearance/thunkAction";
import { readProfileFormByProfileId } from "../../store/profile-form/thunkAction";
import Dropdown from "../../components/core/dropdown";
import {
  BadgeTypes,
  FieldType,
  PositionWindow,
  ScheduleType,
  SessionRating,
  SessionStatus,
  SizeWindow,
  TopicType,
} from "../../constant/enums";
import ChatBadgeHeader from "../../components/chat/chat-badge-header";
import {
  addRequester,
  editRequester,
  readRequester,
} from "../../store/requester/thunkAction";
import {
  addSession,
  editSession,
  readSession,
} from "../../store/session/thunkAction";
import { initializeSocket, socketActions } from "../../store/socket/slice";
import { tokenAction } from "../../store/token/slice";
import {
  createSocketToken,
  refreshSocketToken,
} from "../../store/token/thunkAction";
import ChatContent from "../../components/chat/chat-content";
import {
  queryMessageBySessionId,
  sendMessage,
} from "../../store/message/thunkAction";
import { messageAction } from "../../store/message/slice";
import {
  listProfileBusinessHourByProfileId,
  listProfileSpecialDayByProfileId,
} from "../../store/profile-business/thunkAction";
import { requestTrackingInfo, sendStyleIframe } from "../../utils/event";
import { readProfileRouterByProfileId } from "../../store/profile-router/thunkAction";
import i18n from "../../i18n";
import ChatFooter from "../../components/chat/chat-footer";
import { getImageUrl } from "../../utils/image";
import { requesterActions } from "../../store/requester/slice";
import { SessionAction } from "../../store/session/slice";
import Popup from "../../components/core/popup";

const MAX_FILE_SIZE = 1024 * 1024;
const ACCEPTED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/pdf",
  "text/plain",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

const WidgetPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const domain = searchParams.get("origin");
  const windowWidth = searchParams.get("windowWidth");
  const [fields, setFields] = useState([]);
  const [preChat, setPreChat] = useState({});
  const [frame, setFrame] = useState({});
  const [isMinimized, setIsMinimized] = useState(true);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [windowProfile, setWindowProfile] = useState({});
  const [chatBadge, setChatBadge] = useState({});
  const [content, setContent] = useState({});
  const [text, setText] = useState("");
  const [files, setFiles] = useState([]);
  const [messageGroup, setMessageGroup] = useState({});
  const bottomRef = useRef(null);
  const [schedule, setSchedule] = useState(ScheduleType.ENTIRE_DAY);
  const [isSupport, setIsSupport] = useState(false);
  const [isBlockRequester, setIsBlockRequester] = useState(false);
  const [isOpenStatsSession, setIsOpenStatsSession] = useState(false);
  const [rating, setRating] = useState(SessionRating.GOOD);
  const [comment, setComment] = useState("");
  const [isActiveRouter, setIsActiveRouter] = useState(false);
  const [groupDefaultId, setGroupDefaultId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [titleGroup, setTitleGroup] = useState("");
  const [groupId, setGroupId] = useState(null);
  const [tracking, setTracking] = useState(null);
  const [sessionStatus, setSessionStatus] = useState(SessionStatus.NEW);
  const widgetRef = useRef(null);
  const widgetErrorRef = useRef(null);
  const widgetBtnRef = useRef(null);
  const widgetBadgeRef = useRef(null);
  const [display, setDisplay] = useState(0);
  const buttonEmojiRef = useRef(null);
  const pickerRef = useRef(null);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
  const [showPicker, setShowPicker] = useState(false);
  const [isShowHeader, setIsShowHeader] = useState(true);
  const [hasMountedIcon, setHasMountedIcon] = useState(false);
  const [hasMountedBadge, setHasMountedBadge] = useState(false);
  const [hasMountedPopup, setHasMountedPopup] = useState(false);
  const [hasFromData, setHasFormData] = useState(false);
  const [tokenRefreshed, setTokenRefreshed] = useState(false);
  const [replyMessage, setReplyMessage] = useState(null);
  const [replyName, setReplyName] = useState("");
  const [replyMessageId, setReplyMessageId] = useState(null);
  const replyMessageRef = useRef(null);
  const [isExpand, setIsExpand] = useState(false);
  const [showIconExpand, setShowIconExpand] = useState(false);
  const [isOpenPopupError, setIsOpenPopupError] = useState(false);
  const [error, setError] = useState("");
  const [displayBadge, setDisplayBadge] = useState(true);
  const fileInputRef = useRef(null);

  const profileManage = useSelector((state) => state.profileManage);
  const profileAppearanceManage = useSelector(
    (state) => state.profileAppearanceManage
  );
  const profileFormManage = useSelector((state) => state.profileFormManage);
  const profileBusinessManage = useSelector(
    (state) => state.profileBusinessManage
  );
  const requesterManage = useSelector((state) => state.requesterManage);
  const tokenManage = useSelector((state) => state.tokenManage);
  const socketManage = useSelector((state) => state.socketManage);
  const sessionManage = useSelector((state) => state.sessionManage);
  const messageManage = useSelector((state) => state.messageManage);
  const profileRouterManage = useSelector((state) => state.profileRouterManage);
  const profile = _.get(profileManage, "profile");
  const isDomainUnknown = _.get(profileManage, "isDomainUnknown", false);
  const staffNameDefault = _.get(profile, "agentName", "");
  const profileRouter = _.get(profileRouterManage, "profileRouter");
  const profileBusinessHours = _.get(
    profileBusinessManage,
    "profileBusinessHours",
    []
  );
  const profileSpecialDays = _.get(
    profileBusinessManage,
    "profileSpecialDays",
    []
  );
  const profileAppearance = _.get(profileAppearanceManage, "profileAppearance");
  const profileForm = _.get(profileFormManage, "profileForm");
  const requester = _.get(requesterManage, "requester");
  const localFormRequester = _.get(requesterManage, "localFormRequester");
  const socketToken = _.get(tokenManage, "socketToken");
  const isSound = _.get(socketManage, "isSound");
  const isConnected = _.get(socketManage, "isConnected");
  const auth = _.get(socketManage, "auth", {});
  const socketMessage = _.get(socketManage, "message");
  const staffChangeRequesterStatus = _.get(
    socketManage,
    "staffChangeRequesterStatus"
  );
  const sessionChangeToRequester = _.get(
    socketManage,
    "sessionChangeToRequester"
  );
  const session = _.get(sessionManage, "session");
  const sessionId = _.get(session, "_id");
  const messages = _.get(messageManage, "messages", []);
  const lastMessage = _.last(messages);
  const lastMessageId = _.get(lastMessage, "_id");
  const skip = _.get(messageManage, "skip", 0);
  const limit = _.get(messageManage, "limit", 10);
  const total = _.get(messageManage, "total", 0);
  const isLoadingSendMessage = _.get(
    messageManage,
    "isLoadingSendMessage",
    false
  );
  const isLoadingQueryMessage = _.get(
    messageManage,
    "isLoadingQueryMessage",
    false
  );

  const enabledChatBadge = _.get(chatBadge, "enabled", false);
  const badgeType = _.get(chatBadge, "badgeType", BadgeTypes.TEXT_ONLY);
  const requesterId = _.get(requester, "_id");
  const size = _.get(windowProfile, "size", SizeWindow.SMALL);

  const mapDropdownGroup = {
    id: "value",
    name: "key",
  };

  const isShowWidget =
    profile._id &&
    profile.isActive &&
    _.get(profile, "profileSetting.isActive", true) &&
    !_.get(profile, "profileSetting.isExpired", false);

  useEffect(() => {
    if (localFormRequester && !_.isEmpty(fields)) {
      const { groupId, ...formData } = localFormRequester;
      setFormData(formData);
      const newErrors = _(fields).reduce((acc, field) => {
        const value = localFormRequester[field.key];

        const isEmpty = field.isRequired ? _.isEmpty(_.trim(value)) : false;

        if (isEmpty) {
          acc[field.key] = `${field.title} ${t("widget.is_required")}`;
        }

        if (
          field.fieldType === FieldType.EMAIL &&
          !_.isEmpty(_.trim(value)) &&
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ) {
          acc[field.key] = t("widget.email_error");
        }

        if (
          field.fieldType === FieldType.PHONE &&
          !_.isEmpty(_.trim(value)) &&
          !/^\d{8,10}$/.test(value)
        ) {
          acc[field.key] = t("widget.phone_error");
        }

        return acc;
      }, {});

      if (isActiveRouter) {
        const group = _.find(groups, (group) => group.value === groupId);
        if (!group) {
          newErrors["group-router-widget"] = t(
            "widget.group_router_error"
          ).replace("{{titleGroup}}", titleGroup);
        } else {
          setGroupId(groupId);
        }
      }

      if (_.isEmpty(newErrors)) {
        setHasFormData(true);
      } else {
        setHasFormData(false);
        setErrors(newErrors);
      }
    }
  }, [localFormRequester, fields, t, isActiveRouter, groups, titleGroup]);

  useEffect(() => {
    if (sessionId && !isMinimized) {
      dispatch(
        editSession({
          id: sessionId,
          data: {
            requesterSeenAt: +Moment.utc(),
          },
        })
      );
    }
  }, [dispatch, sessionId, isMinimized, socketMessage]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        buttonEmojiRef.current &&
        !buttonEmojiRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  useEffect(() => {
    setIsShowHeader(true);
    const isPreChat = _.get(preChat, "isPreChat", false);

    if (isBlockRequester) {
      setDisplay(1);

      return;
    }

    if (!isSupport) {
      setDisplay(5);

      return;
    }

    if (!isConnected) {
      setDisplay(2);

      return;
    }

    if (isOpenStatsSession) {
      setDisplay(4);
      setIsShowHeader(false);

      return;
    }

    if (sessionStatus === SessionStatus.PENDING) {
      setDisplay(6);

      return;
    }

    if (
      _.includes([SessionStatus.NEW, SessionStatus.WAITING], sessionStatus) &&
      !isPreChat
    ) {
      setDisplay(6);

      return;
    }

    if (!hasFromData && !_.isEmpty(fields)) {
      setDisplay(3);

      return;
    }

    setDisplay(6);
  }, [
    isBlockRequester,
    isConnected,
    sessionStatus,
    isSupport,
    isOpenStatsSession,
    hasFromData,
    fields,
    preChat,
  ]);

  useEffect(() => {
    const sessionId = _.get(session, "_id");
    const status = _.get(session, "status", SessionStatus.NEW);

    if (sessionId) {
      setSessionStatus(status);
    }
  }, [session]);

  useEffect(() => {
    if (!session._id || !domain) {
      return;
    }

    const storedMinimized = sessionStorage.getItem(
      `isMinimized-IziChat-${domain}`
    );
    const isStoredMinimized = !storedMinimized || storedMinimized === "true";

    setIsMinimized(isStoredMinimized);
  }, [session._id, domain]);

  useEffect(() => {
    const profileRouterId = _.get(profileRouter, "_id");
    const groups = _.get(profileRouter, "groups", []);
    const isActive = _.get(profileRouter, "isActive", false);
    const title = _.get(profileRouter, "title");
    const groupDefaultId = _.get(profileRouter, "groupDefaultId", null);

    if (profileRouterId) {
      setGroups(groups);
      setTitleGroup(title);
      setIsActiveRouter(isActive);
      setGroupDefaultId(groupDefaultId);
    }
  }, [profileRouter, dispatch]);

  useEffect(() => {
    if (!requesterId || !tracking || !domain) {
      return;
    }

    const { visitorPath, ...dataTracking } = tracking;

    setTimeout(
      () => [
        dispatch(
          editRequester({
            id: requesterId,
            data: {
              domain,
              attributes: [
                { key: "tracking", value: JSON.stringify(dataTracking) },
                { key: "visitorPath", value: JSON.stringify(visitorPath) },
              ],
            },
          })
        ),
      ],
      2000
    );
  }, [tracking, dispatch, requesterId, domain]);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const topic = _.get(data, "topic");

        if (topic === TopicType.TRACKING_INFO) {
          const domain = _.get(data, "domain");
          const location = _.get(data, "location");
          const browser = _.get(data, "browser");
          const platform = _.get(data, "platform");
          const timestamp = _.get(data, "timestamp");
          const visitorPath = _.get(data, "visitorPath", []);

          const tracking = {
            domain,
            location,
            browser,
            platform,
            timestamp,
            visitorPath,
          };

          setTracking(tracking);
        }
      } catch (err) {}
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const isBlocked = _.get(
      _.find(requester.attributes, { key: "isBlocked" }),
      "value",
      false
    );

    setIsBlockRequester(isBlocked);
  }, [requester]);

  useEffect(() => {
    const profileId = _.get(profile, "_id");
    const schedule = _.get(profile, "schedule");
    const language = _.get(profile, "language", "en");

    if (profileId) {
      i18n.changeLanguage(language);
      sessionStorage.setItem("language", language);
      dispatch(readProfileAppearanceByProfileId(profileId));
      dispatch(readProfileFormByProfileId(profileId));
      dispatch(listProfileBusinessHourByProfileId(profileId));
      dispatch(listProfileSpecialDayByProfileId(profileId));
      dispatch(readProfileRouterByProfileId(profileId));
      setSchedule(schedule);
    }
  }, [dispatch, profile]);

  useEffect(() => {
    const checkRef = () => {
      if (widgetBtnRef.current && !hasMountedIcon) {
        const height = widgetBtnRef.current.offsetHeight;
        const width = widgetBtnRef.current.offsetWidth;

        if (height && width) {
          setHasMountedIcon(true);
        }
      }
    };

    const interval = setInterval(checkRef, 100);

    return () => clearInterval(interval);
  }, [hasMountedIcon]);

  useEffect(() => {
    const checkRef = () => {
      if (widgetBadgeRef.current && !hasMountedBadge) {
        const height = widgetBadgeRef.current.offsetHeight;
        const width = widgetBadgeRef.current.offsetWidth;

        if (height && width) {
          setHasMountedBadge(true);
        }
      }
    };

    const interval = setInterval(checkRef, 100);

    return () => clearInterval(interval);
  }, [hasMountedBadge]);

  useEffect(() => {
    const checkRef = () => {
      if (widgetRef.current && !hasMountedPopup) {
        const height = widgetRef.current.offsetHeight;
        const width = widgetRef.current.offsetWidth;

        if (height && width) {
          setHasMountedPopup(true);
        }
      }
    };

    const interval = setInterval(checkRef, 100);

    return () => clearInterval(interval);
  }, [hasMountedPopup]);

  useEffect(() => {
    let width = "auto";
    let height = "auto";

    const position = _.get(windowProfile, "position", PositionWindow.LEFT);
    const offset = _.get(windowProfile, "offset", 1);

    let left = position === PositionWindow.LEFT ? `${offset * 10}px` : "auto";
    let right = position === PositionWindow.RIGHT ? `${offset * 10}px` : "auto";
    let bottom = isMinimized && !isDomainUnknown ? "20px" : "0px";

    if (isDomainUnknown) {
      height = "320px";
      width = "320px";
      left = "auto";
      right = "10px";
    } else if (isMinimized) {
      height = "56px";
      width = "56px";
      if (
        enabledChatBadge &&
        displayBadge &&
        sessionStatus === SessionStatus.NEW &&
        hasMountedBadge
      ) {
        height = widgetBadgeRef.current.offsetHeight + "px";
        width = widgetBadgeRef.current.offsetWidth + "px";
        if (badgeType === BadgeTypes.CUSTOM_IMAGE) {
          bottom = "5px";
        }
      }
      if (hasMountedIcon) {
        height = widgetBtnRef.current.offsetHeight + "px";
        width = widgetBtnRef.current.offsetWidth + "px";
      }
    } else {
      height = "38px";
      if (hasMountedPopup) {
        height =
          display === 1 || display === 5 || display === 2
            ? "500px"
            : widgetRef.current.offsetHeight + "px";
        width = widgetRef.current.offsetWidth + "px";
      }
    }

    const style = {
      height,
      width,
      left,
      right,
      bottom,
    };

    sendStyleIframe(style);

    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "auto" });
    }

    setTimeout(
      () => [
        sendStyleIframe({
          display: "flex",
        }),
      ],
      1000
    );
  }, [
    isMinimized,
    windowProfile,
    windowWidth,
    hasMountedIcon,
    hasMountedPopup,
    display,
    isDomainUnknown,
    enabledChatBadge,
    displayBadge,
    badgeType,
    sessionStatus,
    hasMountedBadge,
    size,
  ]);

  useEffect(() => {
    setWindowProfile(_.get(profileAppearance, "window", {}));
    setChatBadge(_.get(profileAppearance, "chatBadge", {}));
    setContent(_.get(profileAppearance, "content", {}));
  }, [profileAppearance]);

  // get socket token local
  useEffect(() => {
    dispatch(readProfileByDomainWidget(domain));
    dispatch(tokenAction.getSocketToken(domain));
    dispatch(requesterActions.getLocalFormRequester(domain));
  }, [dispatch, domain]);

  // connect socket with socket token or create requester
  useEffect(() => {
    let timeoutId = null;

    if (socketToken) {
      const cleanup = dispatch(initializeSocket(socketToken));

      if (!tokenRefreshed) {
        dispatch(
          refreshSocketToken({
            socketToken,
          })
        );
        setTokenRefreshed(true);
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      return () => {
        cleanup();
      };
    }

    if (!socketToken && domain) {
      timeoutId = setTimeout(() => {
        dispatch(addRequester({ domain }));
      }, 1000);

      return () => {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      };
    }
  }, [dispatch, socketToken, domain, tokenRefreshed]);

  // create socket token from requesterId
  useEffect(() => {
    const requesterId = _.get(requester, "_id");

    if (requesterId && !socketToken) {
      dispatch(
        createSocketToken({
          requesterId,
        })
      );
      setTokenRefreshed(true);
    }
  }, [dispatch, requester, socketToken]);

  // read requester from socket
  useEffect(() => {
    const requesterId = _.get(auth, "requesterId");
    if (requesterId && !requester._id) {
      dispatch(readRequester(requesterId));
    }
  }, [dispatch, auth, requester._id]);

  useEffect(() => {
    const requesterId = _.get(requester, "_id");
    const accountId = _.get(requester, "accountId");
    const name = _.get(requester, "name");

    if (requesterId && !session._id && domain) {
      const dataSession = {
        accountId,
        requesterId,
        name,
        domain,
        addTime: +Moment.utc(),
        updateTime: +Moment.utc(),
        status: SessionStatus.NEW,
      };

      dispatch(addSession(dataSession));
    }
  }, [dispatch, requester, session._id, domain]);

  useEffect(() => {
    const profileFormId = _.get(profileForm, "_id");
    const fields = _.get(profileForm, "fields", []);
    const preChat = _.get(profileForm, "preChat", {});
    const frame = _.get(profileForm, "frame", {});
    const isAgentActiveChat = _.get(preChat, "isAgentActiveChat", false);
    const sessionId = _.get(session, "_id");
    const isAgentActive = _.get(session, "isAgentActive", false);

    if (!profileFormId) {
      return;
    }

    setFields(fields);
    setPreChat(preChat);
    setFrame(frame);

    if (!sessionId) {
      return;
    }

    const data = {
      ...(isAgentActiveChat && !isAgentActive && { isAgentActive: true }),
      ...(!isAgentActiveChat && isAgentActive && { isAgentActive: false }),
    };

    if (!_.isEmpty(data)) {
      dispatch(
        editSession({
          id: sessionId,
          data,
        })
      );
    }
  }, [dispatch, session, profileForm]);

  const groupMessageByDate = (messages) => {
    return _(messages)
      .groupBy((msg) => {
        const msgDate = Moment(msg.addTime);
        return msgDate.isSame(Moment(), "day")
          ? ""
          : msgDate.format("DD-MM-YYYY");
      })
      .value();
  };

  useEffect(() => {
    setMessageGroup(groupMessageByDate(messages));
  }, [messages]);

  useEffect(() => {
    if (!_.isNil(requester._id)) {
      requestTrackingInfo();
    }
  }, [dispatch, requester._id]);

  // socket message
  useEffect(() => {
    if (socketMessage) {
      if (isSound) {
        const audio = new Audio("/sounds/receiving-message.mp3");
        audio.play().catch((err) => {});
      }

      dispatch(messageAction.addMessage(socketMessage));
      dispatch(socketActions.clearMessage());

      if (bottomRef.current) {
        setTimeout(() => {
          bottomRef.current.scrollIntoView({ behavior: "auto" });
        }, 1000);
      }
    }
  }, [dispatch, socketMessage, isSound]);

  // socket change status requester
  useEffect(() => {
    if (!staffChangeRequesterStatus) {
      return;
    }

    const socketRequesterId = _.get(staffChangeRequesterStatus, "requesterId");

    if (requester._id === socketRequesterId) {
      socketActions.clearStaffChangeRequesterStatus();
      dispatch(readRequester(requester._id));
    }
  }, [dispatch, staffChangeRequesterStatus, requester._id]);

  // socket status session
  useEffect(() => {
    if (!sessionChangeToRequester) {
      return;
    }

    const socketSessionId = _.get(sessionChangeToRequester, "_id");
    const newStatus = _.get(sessionChangeToRequester, "status");

    if (session._id === socketSessionId) {
      socketActions.clearSessionChangeToRequester();
      dispatch(readSession(session._id));

      if ([SessionStatus.SERVED, SessionStatus.CLOSED].includes(newStatus)) {
        setIsOpenStatsSession(true);
      }
    }
  }, [dispatch, sessionChangeToRequester, session._id]);

  const handleTogglePicker = () => {
    if (buttonEmojiRef.current) {
      setPickerPosition({
        top: 210,
        left: 10,
      });
    }
    setShowPicker(!showPicker);
  };

  const closePopupError = () => {
    setIsOpenPopupError(false);
  };

  // edit requester / session
  const chatNow = async () => {
    const accountId = _.get(profile, "accountId");
    const requesterId = _.get(requester, "_id");
    const requesterName = _.get(requester, "name");
    const sessionId = _.get(session, "_id");
    const status = _.get(session, "status");

    if (!accountId || !requesterId) {
      return;
    }

    const isOk = validateForm();

    if (!isOk) {
      return;
    }

    dispatch(
      requesterActions.setLocalFormRequester({
        formData: { ...formData, groupId },
        domain,
      })
    );

    const { name, ...restData } = formData;
    const formAttributes = _.map(restData, (value, key) => ({ key, value }));
    const changeRequester = {
      name,
      attributes: formAttributes,
    };

    try {
      await dispatch(
        editRequester({ id: requesterId, data: changeRequester })
      ).unwrap();
    } catch (error) {}

    let dataSession = {
      name: name || requesterName,
      groupId: groupId === "all" ? null : groupId || groupDefaultId,
      updateTime: +Moment.utc(),
    };

    if (status === SessionStatus.NEW) {
      dataSession["status"] = SessionStatus.WAITING;
    }

    if (sessionId) {
      try {
        await dispatch(
          editSession({ id: sessionId, data: dataSession })
        ).unwrap();
      } catch (error) {}
    }
  };

  useEffect(() => {
    dispatch(messageAction.setSessionId(session._id));
  }, [dispatch, session._id]);

  useEffect(() => {
    if (!isConnected) {
      dispatch(messageAction.clearMessage());
      return;
    }

    if (session._id && requester._id) {
      dispatch(
        queryMessageBySessionId({
          sessionId: session._id,
          filter: {
            skip,
            limit,
            requesterId: requester._id,
          },
        })
      );
    }
  }, [dispatch, session._id, skip, limit, requester._id, isConnected]);

  useEffect(() => {
    if (!replyMessageId) {
      return;
    }

    if (isLoadingQueryMessage) {
      return;
    }

    const hasMessage = messages.some((msg) => msg._id === replyMessageId);

    if (hasMessage) {
      setReplyMessageId(null);
    } else {
      if (messages.length >= total) {
        return;
      }
      dispatch(messageAction.setSkip(messages.length));
    }

    setTimeout(() => {
      const el = document.getElementById(`message-${replyMessageId}`);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "center" });
        el.classList.add("highlight-reply");

        setTimeout(() => {
          el.classList.remove("highlight-reply");
        }, 2000);
      }
    }, 1000);
  }, [
    dispatch,
    replyMessageId,
    skip,
    limit,
    total,
    messages,
    requester._id,
    session._id,
    isLoadingQueryMessage,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownSelect = (key, selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      [key]: selectedOption?.key || "",
    }));
  };

  const fileTypeIcon = (name, type) => {
    const ext = name.split(".").pop()?.toLowerCase() || "";

    if (type.includes("pdf") || ext === "pdf") return "pdf";
    if (type.includes("word") || ["doc", "docx"].includes(ext)) return "word";
    if (type.includes("excel") || ["xls", "xlsx"].includes(ext)) return "excel";

    return "default";
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (_.isEmpty(files)) {
      return;
    }

    if (files.length > 5) {
      setError(t("session.file_limit"));
      resetFileInput();
      setIsOpenPopupError(true);
      return false;
    }

    const validFiles = _.filter(files, (file) => {
      const fileType = file.type;
      const fileSize = file.size;

      if (!ACCEPTED_TYPES.includes(fileType)) {
        setError(t("session.send_file_error"));
        setIsOpenPopupError(true);
        return false;
      }

      if (fileSize > MAX_FILE_SIZE) {
        setError(t("session.file_too_large"));
        setIsOpenPopupError(true);
        return false;
      }

      return true;
    });

    if (_.isEmpty(validFiles)) {
      resetFileInput();
      return;
    }

    const fileDataList = await Promise.all(
      _.map(validFiles, (file) => {
        return new Promise((resolve) => {
          const isImage = _.startsWith(file.type, "image");
          const fileIcon = fileTypeIcon(file.name, file.type);

          if (isImage) {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve({
                isImage,
                fileIcon,
                image: reader.result,
                file,
              });
            };
            reader.readAsDataURL(file);
          } else {
            resolve({
              isImage,
              fileIcon,
              file,
            });
          }
        });
      })
    );

    setFiles(_.sortBy(fileDataList, (item) => !item.isImage));
    resetFileInput();
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles((prevFiles) =>
      _.filter(prevFiles, (_, index) => index !== indexToRemove)
    );
  };

  const validateForm = () => {
    const newErrors = _(fields).reduce((acc, field) => {
      const value = formData[field.key];

      const isEmpty = field.isRequired ? _.isEmpty(_.trim(value)) : false;

      if (isEmpty) {
        acc[field.key] = `${field.title} ${t("widget.is_required")}`;
      }

      if (
        field.fieldType === FieldType.EMAIL &&
        !_.isEmpty(_.trim(value)) &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      ) {
        acc[field.key] = t("widget.email_error");
      }

      if (
        field.fieldType === FieldType.PHONE &&
        !_.isEmpty(_.trim(value)) &&
        !/^\d{8,10}$/.test(value)
      ) {
        acc[field.key] = t("widget.phone_error");
      }

      return acc;
    }, {});

    if (isActiveRouter && !groupId) {
      newErrors["group-router-widget"] = t("widget.group_router_error").replace(
        "{{titleGroup}}",
        titleGroup
      );
    }

    setErrors(newErrors);

    return _.isEmpty(newErrors);
  };

  const sendRequesterMessage = async () => {
    const accountId = _.get(profile, "accountId");
    const sessionId = _.get(session, "_id");
    const requesterId = _.get(requester, "_id");
    const requesterName = _.get(requester, "name");
    const status = _.get(session, "status");

    if (
      !sessionId ||
      _.includes(
        [SessionStatus.CLOSED, SessionStatus.SERVED],
        status || isLoadingSendMessage
      )
    ) {
      return;
    }

    if (!text.trim() && _.isEmpty(files)) {
      return;
    }

    const formData = new FormData();

    formData.append("accountId", accountId);
    formData.append("sessionId", sessionId);
    formData.append("requesterId", requesterId);
    formData.append("name", requesterName);
    formData.append("content", text || "");
    formData.append("type", files.length ? "FILE" : "TEXT");
    formData.append("addTime", +Moment.utc());
    formData.append("updateTime", +Moment.utc());

    _.forEach(files, (file) => {
      const previewUrl = URL.createObjectURL(file.file);
      formData.append("files", file.file);
      formData.append("fileNames[]", _.get(file, "file.name", ""));
      formData.append("previewUrls[]", previewUrl);
    });

    if (replyMessage) {
      formData.append("replyMessageId", _.get(replyMessage, "_id"));
    }

    setText("");
    setFiles([]);
    setReplyMessage(null);
    setShowIconExpand(false);
    setIsExpand(false);

    try {
      const result = await dispatch(
        sendMessage({ data: formData, isFormData: !_.isEmpty(files) })
      ).unwrap();
      const messageId = _.get(result, "_id");

      const dataSession = {
        updateTime: +Moment.utc(),
        lastMessage: text || "",
        isRequesterLastMessage: true,
        requesterSeenAt: +Moment.utc(),
      };

      if (!session.groupId) {
        dataSession["groupId"] =
          groupId === "all" ? null : groupId || groupDefaultId;
      }

      if (status === SessionStatus.NEW) {
        dataSession["status"] = SessionStatus.WAITING;
      }

      if (messageId) {
        dispatch(
          editSession({
            id: sessionId,
            data: dataSession,
          })
        );
      }
    } catch (error) {
      const errorCode = _.get(error, "errorCode");
      if (errorCode === "FILE_NOT_ALLOWED") {
        setError(t("session.send_file_error"));
      } else if (errorCode === "FILE_TOO_LARGE") {
        setError(t("session.file_too_large"));
      } else {
        setError(t("session.send_message_error"));
      }
      setIsOpenPopupError(t("session.send_message_error"));
    }

    if (bottomRef.current) {
      setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: "auto" });
      }, 1000);
    }
  };

  const onRatingSession = async () => {
    const sessionId = _.get(session, "_id");

    if (!sessionId) {
      return;
    }

    const data = {
      rating,
      comment,
    };

    try {
      await dispatch(
        editSession({
          id: sessionId,
          data,
        })
      ).unwrap();
    } catch (error) {}

    dispatch(SessionAction.clearSession());
  };

  useEffect(() => {
    const isNowInBusinessTime = () => {
      Moment.locale("en");
      const now = Moment();

      if (schedule === ScheduleType.ENTIRE_DAY) {
        return true;
      }

      const special = _.find(profileSpecialDays, (day) =>
        now.isBetween(Moment(day.startAt), Moment(day.endAt), null, "[]")
      );

      const target =
        special ||
        _.find(
          profileBusinessHours,
          (bh) => bh.date === now.format("dddd").toUpperCase()
        );

      if (!target || target.isClosed) return false;

      return _.some(target.openHour, ({ startTime, endTime }) => {
        const start = Moment(startTime, "HH:mm");
        const end = Moment(endTime, "HH:mm");
        const nowTime = Moment(now.format("HH:mm"), "HH:mm");
        return nowTime.isBetween(start, end, null, "[)");
      });
    };

    const checkBusiness = () => {
      const active = isNowInBusinessTime();

      setIsSupport(active);
    };

    checkBusiness();

    const interval = setInterval(() => {
      checkBusiness();
    }, 60 * 1000); //1p

    return () => clearInterval(interval);
  }, [profileBusinessHours, profileSpecialDays, schedule]);

  const handleEmojiSelect = (emoji) => {
    if (!text.trim()) {
      setText(emoji.native);
    } else {
      setText(text + emoji.native);
    }
  };

  const onReplyMessage = (message) => {
    const messageStaffId = _.get(message, "staffId");
    const requesterId = _.get(message, "requesterId");

    setReplyMessage(message);

    if (requesterId) {
      setReplyName(t("agent.chat.your_message"));
    }
    if (messageStaffId) {
      setReplyName(staffNameDefault || _.get(message, "name"));
    }
  };

  return isDomainUnknown ? (
    <div
      className="widgetChatBox"
      style={{ background: "none" }}
      ref={widgetErrorRef}
    >
      <div>
        <div
          className="header-top"
          style={{ backgroundColor: windowProfile.color || "#003434" }}
        >
          <strong>{t("widget.chat_progress")}</strong>
          <button
            style={{ background: "none", border: "none" }}
            className="widgetChatCloss"
            onClick={() => {
              sessionStorage.setItem(
                `isMinimized-IziChat-${domain}`,
                `${!isMinimized}`
              );
              setIsMinimized(!isMinimized);
            }}
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                fill="#677187"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        className="content h-auto"
        id="widgetChat03"
        style={{ backgroundColor: "#fff" }}
      >
        <div className="text-center mb-3">
          <div className="chat-content-body">
            <div className="overflow-auto">
              <div
                className="logo-center"
                style={{
                  paddingTop: 10,
                  width: "auto",
                  height: "auto",
                }}
              >
                <img
                  src="/img/chat/error.png"
                  alt=""
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 8,
                    objectFit: "cover",
                    marginRight: 12,
                  }}
                />
              </div>
              <br />
              <p className="mb-4 text-center">{t("widget.desc")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div>
      {isShowWidget ? (
        <div>
          {!isMinimized ? (
            <div
              className="widgetChatBox"
              style={{
                background: "none",
                width:
                  size === SizeWindow.SMALL
                    ? "320px"
                    : size === SizeWindow.MEDIUM
                    ? "420px"
                    : "520px",
              }}
              ref={widgetRef}
            >
              <div className="header">
                <div
                  className="header-top"
                  style={{ backgroundColor: windowProfile.color || "#003434" }}
                >
                  <strong>
                    {content.progressChat || t("widget.chat_progress")}
                  </strong>
                  <button
                    style={{ background: "none", border: "none" }}
                    className="widgetChatCloss"
                    onClick={() => {
                      sessionStorage.setItem(
                        `isMinimized-IziChat-${domain}`,
                        `${!isMinimized}`
                      );
                      setIsMinimized(!isMinimized);
                      setDisplayBadge(false);
                    }}
                  >
                    <svg
                      width="33"
                      height="32"
                      viewBox="0 0 33 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                        fill="#677187"
                      />
                    </svg>
                  </button>
                </div>
                <ChatBadgeHeader
                  session={session}
                  profile={profile}
                  onRating={setIsOpenStatsSession}
                  isOpenRating={isOpenStatsSession}
                  isShowHeader={isShowHeader}
                />
              </div>

              <div
                className="content h-auto"
                id="widgetChat01"
                style={
                  display !== 3
                    ? {
                        display: "none",
                      }
                    : {
                        backgroundColor: "#fff",
                      }
                }
              >
                <form
                  className="p-3 pre-chat-form overflow-auto chat-content"
                  id="widgetChat01Form"
                  onSubmit={(e) => e.preventDefault()}
                  style={{
                    maxHeight: "400px",
                  }}
                >
                  <div className="mb-3">
                    <p
                      style={{
                        color: windowProfile.textColor || "#333",
                      }}
                    >
                      {preChat.greeting}
                    </p>
                  </div>
                  {fields.map((field) => {
                    const isVisible = _.get(field, "isVisible", false);
                    return isVisible ? (
                      <div className="mb-3" key={field.key}>
                        <label
                          className="form-label text-uppercase"
                          style={{
                            color: "#333",
                          }}
                        >
                          {field.title}
                          {field.isRequired && (
                            <span className="required">*</span>
                          )}
                        </label>

                        {field.fieldType === FieldType.DROPDOWN ? (
                          <Dropdown
                            config={{
                              style: { width: "100%" },
                              options: field.options,
                              value: formData[field.key],
                              onSelect: (option) =>
                                handleDropdownSelect(field.key, option),
                              placeholder: `${field.title}`,
                              map: {
                                id: "key",
                                name: "title",
                              },
                            }}
                          />
                        ) : field.fieldType === FieldType.ARENA ? (
                          <textarea
                            style={{ width: "100%" }}
                            name={field.key}
                            className={
                              errors[field.key]
                                ? "error form-control"
                                : "form-control"
                            }
                            rows="3"
                            value={formData[field.key] || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          <input
                            type="text"
                            name={field.key}
                            value={formData[field.key] || ""}
                            onChange={handleInputChange}
                            className={
                              errors[field.key]
                                ? "error form-control"
                                : "form-control"
                            }
                          />
                        )}
                        {errors[field.key] && (
                          <span className="error-message">
                            {errors[field.key]}
                          </span>
                        )}
                      </div>
                    ) : (
                      <div key={field.key}></div>
                    );
                  })}
                  {isActiveRouter && (
                    <div
                      className="form-label text-uppercase"
                      style={{
                        color: "#333",
                      }}
                    >
                      <label>{titleGroup || t("widget.group")}</label>
                      <Dropdown
                        config={{
                          style: { width: "100%" },
                          options: groups,
                          value: groupId,
                          onSelect: (option) => {
                            setGroupId(option?.value || null);
                          },
                          placeholder: titleGroup || t("widget.group"),
                          map: mapDropdownGroup,
                        }}
                      />
                      {errors["group-router-widget"] && (
                        <span className="error-message">
                          {errors["group-router-widget"]}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="">
                    <button
                      type="button"
                      style={{
                        backgroundColor: windowProfile.color || "#003434",
                        border: "none",
                      }}
                      onClick={() => chatNow()}
                      className="btn btn-primary w-100"
                    >
                      {content.startChat || t("widget.chat_now")}
                    </button>
                  </div>
                </form>
                <ChatFooter
                  config={{
                    isChat: false,
                    display,
                  }}
                />
              </div>

              <div
                className="content"
                id="widgetChat02"
                style={
                  display !== 6
                    ? {
                        display: "none",
                      }
                    : { backgroundColor: "#fff" }
                }
              >
                <div className="chat-content-body">
                  <div className="overflow-auto">
                    <div className="chat-content-body-in justify-content-end d-flex flex-column gap-3 p-3">
                      <div className="chat-content-body-in justify-content-end d-flex flex-column gap-3">
                        {messages.length < total && (
                          <button
                            onClick={() => {
                              dispatch(messageAction.setSkip(messages.length));
                            }}
                            className="show-more-button btn-primary"
                            style={{
                              backgroundColor: windowProfile.color || "#003434",
                              border: "none",
                            }}
                          >
                            {t("widget.show_more")}
                          </button>
                        )}
                        {_.keys(messageGroup).map((key) => {
                          const messages = messageGroup[key];
                          return (
                            <div key={key}>
                              {messages.map((message, index) => {
                                const nextMessage = messages[index + 1];

                                const isSameSender =
                                  nextMessage &&
                                  message.staffId === nextMessage.staffId &&
                                  message.requesterId ===
                                    nextMessage.requesterId;

                                const isWithin1Minute = nextMessage
                                  ? Moment(nextMessage.addTime).diff(
                                      Moment(message.addTime),
                                      "minutes"
                                    ) === 0
                                  : false;

                                const isShowTime =
                                  !isSameSender || !isWithin1Minute;

                                return (
                                  <div
                                    key={message._id}
                                    id={`message-${message._id}`}
                                    ref={(el) => {
                                      if (message._id === replyMessageId) {
                                        replyMessageRef.current = el;
                                      }
                                    }}
                                  >
                                    <ChatContent
                                      key={message._id}
                                      message={message}
                                      config={{
                                        isWidget: true,
                                        timeFormat: content.timeFormat,
                                        messageStyle: content.messageStyle,
                                        staffNameDefault,
                                        onReplyMessage,
                                        isLastMessage:
                                          lastMessageId === message._id,
                                        isShowTime,
                                        setReplyMessageId,
                                      }}
                                    />
                                    {/* <br /> */}
                                  </div>
                                );
                              })}
                              <div className="color-gray date text-center">
                                {key}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div ref={bottomRef} />
                    </div>
                  </div>
                  <Popup
                    config={{
                      isOpen: isOpenPopupError,
                      onClose: closePopupError,
                      className: "popup-widget",
                    }}
                  >
                    <div className="modal-content">
                      {/* <div className="modal-header">
            <h5 className="modal-title">{t("common.error")}</h5>
          </div> */}
                      <div
                        className="modal-body"
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {error}
                      </div>
                      <br />
                      <div
                        className="modal-footer"
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => closePopupError()}
                        >
                          {t("common.closed")}
                        </button>
                      </div>
                    </div>
                  </Popup>
                </div>
                <ChatFooter
                  config={{
                    isChat: true,
                    onChangeText: setText,
                    text: text,
                    onChangeFile: handleFileChange,
                    onSendMessage: sendRequesterMessage,
                    buttonEmojiRef: buttonEmojiRef,
                    handleTogglePicker: handleTogglePicker,
                    onRemoveImage: handleRemoveFile,
                    files,
                    replyMessage,
                    setReplyMessage,
                    display,
                    replyName,
                    isExpand,
                    showIconExpand,
                    setIsExpand,
                    setShowIconExpand,
                    fileInputRef,
                  }}
                />
                {showPicker && (
                  <div
                    ref={pickerRef}
                    className="widget-picker"
                    style={{
                      position: "fixed",
                      bottom: "100%",
                      left: pickerPosition.left,
                      top: pickerPosition.top,
                      zIndex: 1000,
                      marginBottom: "8px",
                    }}
                  >
                    <Picker
                      data={data}
                      onEmojiSelect={handleEmojiSelect}
                      previewPosition="none"
                      theme="light"
                    />
                  </div>
                )}
              </div>

              <div
                className="content h-auto"
                id="widgetChat03"
                style={
                  display !== 4
                    ? {
                        display: "none",
                      }
                    : { backgroundColor: "#fff" }
                }
              >
                <form className="p-3" onSubmit={(e) => e.preventDefault()}>
                  <div className="text-center mb-3">
                    <div className="logo-center">
                      <img
                        src={getImageUrl(_.get(profile, "imageUrl", ""))}
                        alt="Avatar"
                        style={{
                          width: 50,
                          height: 51,
                          borderRadius: 8,
                          objectFit: "cover",
                          marginRight: 12,
                        }}
                      />
                    </div>
                  </div>
                  <h5 className="mb-4 text-center">
                    {t("widget.staff_support")}
                  </h5>
                  <div className="mb-4">
                    <div className="radio-like-box d-flex gap-3 justify-content-center">
                      <label
                        style={{
                          backgroundColor:
                            rating === SessionRating.GOOD ? "#DBE0FE" : "",
                        }}
                        onClick={() => setRating(SessionRating.GOOD)}
                      >
                        <input
                          name="radio-like"
                          className="d-none"
                          type="radio"
                        />
                        <svg
                          width="31"
                          height="30"
                          viewBox="0 0 31 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.63026 12.5H5.65663C4.27479 12.5 3.15662 13.6182 3.15662 15V25C3.15662 26.3818 4.27479 27.5 5.65663 27.5H20.0316C21.5306 27.5 22.9076 26.6016 23.4545 25.2637L27.8295 16.5137L27.8685 16.4404C28.6644 14.5264 27.7562 12.334 25.8422 11.5381C25.3881 11.3477 24.8998 11.25 24.4066 11.25H18.1566V5C18.1566 3.62305 17.0336 2.5 15.6566 2.5H15.4844C14.348 2.5 13.3093 3.14201 12.8011 4.15836L8.63026 12.5ZM10.6566 14.0527L15.1021 5.16181C15.1517 5.06264 15.253 5 15.3639 5C15.5256 5 15.6566 5.13106 15.6566 5.29272V13.75H24.4066C25.0951 13.75 25.6566 14.3115 25.6517 15.0049C25.6517 15.1562 25.6224 15.3076 25.5687 15.4492L21.1937 24.2236C20.9984 24.6924 20.5394 25 20.0316 25H10.6566V14.0527ZM8.15663 15V25H5.65663V15H8.15663Z"
                            fill={
                              rating === SessionRating.GOOD
                                ? "#156FFF"
                                : "#677187"
                            }
                          />
                        </svg>
                      </label>
                      <label
                        style={{
                          backgroundColor:
                            rating === SessionRating.BAD ? "#FFD1D5" : "",
                        }}
                        onClick={() => setRating(SessionRating.BAD)}
                      >
                        <input
                          name="radio-like"
                          className="d-none"
                          type="radio"
                        />
                        <svg
                          width="31"
                          height="30"
                          viewBox="0 0 31 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24.4067 2.5H8.49424C7.61698 2.50029 6.76758 2.80814 6.09384 3.36997C5.42009 3.9318 4.96465 4.71207 4.80674 5.575L3.21924 14.325C3.12032 14.8656 3.14142 15.4212 3.28103 15.9527C3.42064 16.4842 3.67536 16.9785 4.02716 17.4007C4.37896 17.8228 4.81923 18.1625 5.31684 18.3957C5.81444 18.6289 6.35721 18.7498 6.90674 18.75H12.6067L11.9067 20.5375C11.6156 21.3201 11.5186 22.1617 11.6242 22.9901C11.7297 23.8185 12.0346 24.6088 12.5128 25.2935C12.9909 25.9781 13.628 26.5365 14.3693 26.9208C15.1107 27.3051 15.9342 27.5039 16.7692 27.5C17.0097 27.4995 17.2449 27.4297 17.4467 27.2988C17.6484 27.168 17.8082 26.9818 17.9067 26.7625L21.4692 18.75H24.4067C25.4013 18.75 26.3551 18.3549 27.0584 17.6517C27.7617 16.9484 28.1567 15.9946 28.1567 15V6.25C28.1567 5.25544 27.7617 4.30161 27.0584 3.59835C26.3551 2.89509 25.4013 2.5 24.4067 2.5ZM19.4067 17.2375L16.0067 24.8875C15.6589 24.7822 15.3362 24.6069 15.0587 24.3722C14.7811 24.1375 14.5546 23.8485 14.393 23.5229C14.2314 23.1974 14.1381 22.8422 14.119 22.4792C14.0999 22.1163 14.1552 21.7532 14.2817 21.4125L14.9442 19.625C15.0854 19.2472 15.1331 18.8408 15.0831 18.4406C15.0332 18.0404 14.8872 17.6581 14.6576 17.3266C14.4279 16.995 14.1215 16.7239 13.7644 16.5365C13.4072 16.349 13.0101 16.2507 12.6067 16.25H6.90674C6.7231 16.2503 6.54165 16.2101 6.3753 16.1324C6.20894 16.0546 6.06177 15.9411 5.94424 15.8C5.82382 15.6608 5.73562 15.4968 5.68592 15.3196C5.63622 15.1425 5.62626 14.9565 5.65674 14.775L7.24424 6.025C7.29748 5.7338 7.45235 5.47095 7.68125 5.28325C7.91016 5.09555 8.19825 4.99517 8.49424 5H19.4067V17.2375ZM25.6567 15C25.6567 15.3315 25.525 15.6495 25.2906 15.8839C25.0562 16.1183 24.7383 16.25 24.4067 16.25H21.9067V5H24.4067C24.7383 5 25.0562 5.1317 25.2906 5.36612C25.525 5.60054 25.6567 5.91848 25.6567 6.25V15Z"
                            fill={
                              rating === SessionRating.BAD
                                ? "#ED2A3C"
                                : "#677187"
                            }
                          />
                        </svg>
                      </label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <textarea
                      rows="4"
                      value={comment}
                      className="form-control"
                      placeholder={t("widget.write_comment")}
                      onChange={(e) => setComment(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="">
                    <button
                      className="btn btn-primary w-100"
                      style={{
                        backgroundColor: windowProfile.color || "#003434",
                        border: "none",
                      }}
                      onClick={() => {
                        onRatingSession();
                        setIsOpenStatsSession(false);
                      }}
                    >
                      {t("common.send")}
                    </button>
                  </div>
                </form>
                <ChatFooter
                  config={{
                    isChat: false,
                    display,
                  }}
                />
              </div>

              <div
                className="content h-auto"
                id="widgetChat03"
                style={
                  display !== 1
                    ? {
                        display: "none",
                      }
                    : { backgroundColor: "#fff", minHeight: 300 }
                }
              >
                <div className="text-center mb-3">
                  <div className="chat-content-body">
                    <div
                      className="overflow-auto"
                      style={{
                        height: 350,
                      }}
                    >
                      <div
                        className="logo-center"
                        style={{
                          paddingTop: 10,
                          width: "auto",
                          height: "auto",
                        }}
                      >
                        <img
                          src={getImageUrl(_.get(profile, "imageUrl", ""))}
                          alt=""
                          style={{
                            width: 100,
                            height: 100,
                            borderRadius: 8,
                            objectFit: "cover",
                            marginRight: 12,
                          }}
                        />
                      </div>
                      <br />
                      <p className="mb-4 text-center">
                        {content.blockedChat || t("widget.banned")}
                      </p>
                    </div>
                  </div>
                </div>
                <ChatFooter
                  config={{
                    isChat: false,
                    display,
                  }}
                />
              </div>

              <div
                className="content h-auto"
                id="widgetChat03"
                style={
                  display !== 2
                    ? {
                        display: "none",
                      }
                    : { backgroundColor: "#fff", minHeight: 300 }
                }
              >
                <div className="text-center mb-3">
                  <div className="chat-content-body">
                    <div
                      className="overflow-auto"
                      style={{
                        height: 350,
                      }}
                    >
                      <div
                        className="logo-center"
                        style={{
                          paddingTop: 10,
                          width: "auto",
                          height: "auto",
                        }}
                      >
                        <img
                          src={getImageUrl(_.get(profile, "imageUrl", ""))}
                          alt=""
                          style={{
                            width: 100,
                            height: 100,
                            borderRadius: 8,
                            objectFit: "cover",
                            marginRight: 12,
                          }}
                        />
                      </div>
                      <br />
                      <p className="mb-4 text-center">
                        {t("widget.error_connected")}
                      </p>
                    </div>
                  </div>
                </div>
                <ChatFooter
                  config={{
                    isChat: false,
                    display,
                  }}
                />
              </div>

              <div
                className="content h-auto"
                id="widgetChat03"
                style={
                  display !== 5
                    ? {
                        display: "none",
                      }
                    : { backgroundColor: "#fff", minHeight: 300 }
                }
              >
                <div className="text-center mb-3">
                  <div className="chat-content-body">
                    <div
                      className="overflow-auto"
                      style={{
                        height: 350,
                      }}
                    >
                      <div
                        className="logo-center"
                        style={{
                          paddingTop: 10,
                          width: "auto",
                          height: "auto",
                        }}
                      >
                        <img
                          src={getImageUrl(_.get(profile, "imageUrl", ""))}
                          alt=""
                          style={{
                            width: 100,
                            height: 100,
                            borderRadius: 8,
                            objectFit: "cover",
                            marginRight: 12,
                          }}
                        />
                      </div>
                      <br />
                      <p className="mb-4 text-center">
                        {content.outsideWorkingChat || t("widget.not_working")}
                      </p>
                    </div>
                  </div>
                </div>
                <ChatFooter
                  config={{
                    isChat: false,
                    display,
                  }}
                />
              </div>
            </div>
          ) : (
            <div
              className="widgetChatBtn"
              style={{
                display:
                  !enabledChatBadge || !displayBadge ? "inline-flex" : "flex",
              }}
            >
              {enabledChatBadge &&
              displayBadge &&
              sessionStatus === SessionStatus.NEW ? (
                <div>
                  {badgeType === BadgeTypes.CUSTOM_IMAGE && (
                    <div ref={widgetBadgeRef}>
                      <div
                        style={{
                          backgroundColor:
                            chatBadge.backgroundColor || "#003434",
                          borderTopLeftRadius: 8,
                          borderTopRightRadius: 8,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: 25,
                          color: chatBadge.textColor || "black",
                        }}
                      >
                        {chatBadge.title ? (
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              paddingLeft: "5px",
                              width: "80%",
                              maxWidth: "600px",
                            }}
                          >
                            <strong>{chatBadge.title}</strong>
                          </div>
                        ) : (
                          <strong></strong>
                        )}
                        <button
                          style={{ background: "none", border: "none" }}
                          onClick={() => {
                            setDisplayBadge(false);
                          }}
                        >
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                              fill="#677187"
                            />
                          </svg>
                        </button>
                      </div>
                      <img
                        src={getImageUrl(
                          _.get(profileAppearance, "imageUrl", "")
                        )}
                        alt=""
                        style={{
                          minWidth: "250px",
                          maxHeight: "300px",
                          maxWidth: "700px",
                          width: "100%",
                          height: "100%",
                          borderBottomLeftRadius: 8,
                          borderBottomRightRadius: 8,
                        }}
                        onClick={() => {
                          sessionStorage.setItem(
                            `isMinimized-IziChat-${domain}`,
                            `${!isMinimized}`
                          );
                          setIsMinimized(!isMinimized);
                        }}
                      />
                    </div>
                  )}
                  {badgeType === BadgeTypes.TEXT_ONLY && (
                    <div
                      ref={widgetBadgeRef}
                      style={{
                        height: 100,
                        backgroundColor: chatBadge.backgroundColor || "white",
                        color: chatBadge.textColor || "black",
                        borderRadius: 10,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                        onClick={() => {
                          sessionStorage.setItem(
                            `isMinimized-IziChat-${domain}`,
                            `${!isMinimized}`
                          );
                          setIsMinimized(!isMinimized);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            maxWidth: 430,
                            minWidth: 280,
                            flexDirection: "column",
                            padding: 5,
                          }}
                        >
                          <div
                            style={{
                              borderBottom: "2px solid gray",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <strong>{chatBadge.title}</strong>
                          </div>
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {chatBadge.text}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <button
                          style={{ background: "none", border: "none" }}
                          onClick={() => {
                            setDisplayBadge(false);
                          }}
                        >
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                              fill="#677187"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                  {badgeType === BadgeTypes.IMAGE_LEFT && (
                    <div
                      ref={widgetBadgeRef}
                      style={{
                        height: 100,
                        backgroundColor: chatBadge.backgroundColor || "white",
                        color: chatBadge.textColor || "black",
                        borderRadius: 10,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                        onClick={() => {
                          sessionStorage.setItem(
                            `isMinimized-IziChat-${domain}`,
                            `${!isMinimized}`
                          );
                          setIsMinimized(!isMinimized);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            padding: 5,
                          }}
                        >
                          <img
                            src={getImageUrl(
                              _.get(profileAppearance, "imageUrl", "")
                            )}
                            alt=""
                            style={{
                              height: 80,
                              width: 80,
                              borderRadius: 8,
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            maxWidth: 350,
                            minWidth: 200,
                            flexDirection: "column",
                            padding: 5,
                          }}
                        >
                          <div
                            style={{
                              borderBottom: "2px solid gray",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <strong>{chatBadge.title}</strong>
                          </div>
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {chatBadge.text}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <button
                          style={{ background: "none", border: "none" }}
                          onClick={() => {
                            setDisplayBadge(false);
                          }}
                        >
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                              fill="#677187"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                  {badgeType === BadgeTypes.IMAGE_RIGHT && (
                    <div
                      ref={widgetBadgeRef}
                      style={{
                        height: 100,
                        backgroundColor: chatBadge.backgroundColor || "white",
                        color: chatBadge.textColor || "black",
                        borderRadius: 10,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                        onClick={() => {
                          sessionStorage.setItem(
                            `isMinimized-IziChat-${domain}`,
                            `${!isMinimized}`
                          );
                          setIsMinimized(!isMinimized);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            maxWidth: 350,
                            minWidth: 200,
                            flexDirection: "column",
                            padding: 5,
                          }}
                        >
                          <div
                            style={{
                              borderBottom: "2px solid gray",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <strong>{chatBadge.title}</strong>
                          </div>
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {chatBadge.text}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            padding: 5,
                          }}
                        >
                          <img
                            src={getImageUrl(
                              _.get(profileAppearance, "imageUrl", "")
                            )}
                            alt=""
                            style={{
                              height: 80,
                              width: 80,
                              borderRadius: 8,
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <button
                          style={{ background: "none", border: "none" }}
                          onClick={() => {
                            setDisplayBadge(false);
                          }}
                        >
                          <svg
                            width="33"
                            height="32"
                            viewBox="0 0 33 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.2441 16.0002L22.4941 10.7585C22.651 10.6016 22.7392 10.3887 22.7392 10.1668C22.7392 9.9449 22.651 9.73207 22.4941 9.57515C22.3372 9.41823 22.1243 9.33008 21.9024 9.33008C21.6805 9.33008 21.4677 9.41823 21.3108 9.57515L16.0691 14.8252L10.8274 9.57515C10.6705 9.41823 10.4577 9.33008 10.2357 9.33008C10.0138 9.33008 9.801 9.41823 9.64408 9.57515C9.48716 9.73207 9.39901 9.9449 9.39901 10.1668C9.39901 10.3887 9.48716 10.6016 9.64408 10.7585L14.8941 16.0002L9.64408 21.2418C9.56597 21.3193 9.50398 21.4115 9.46167 21.513C9.41937 21.6146 9.39758 21.7235 9.39758 21.8335C9.39758 21.9435 9.41937 22.0524 9.46167 22.154C9.50398 22.2555 9.56597 22.3477 9.64408 22.4252C9.72155 22.5033 9.81372 22.5653 9.91527 22.6076C10.0168 22.6499 10.1257 22.6717 10.2357 22.6717C10.3458 22.6717 10.4547 22.6499 10.5562 22.6076C10.6578 22.5653 10.7499 22.5033 10.8274 22.4252L16.0691 17.1752L21.3108 22.4252C21.3882 22.5033 21.4804 22.5653 21.5819 22.6076C21.6835 22.6499 21.7924 22.6717 21.9024 22.6717C22.0124 22.6717 22.1213 22.6499 22.2229 22.6076C22.3244 22.5653 22.4166 22.5033 22.4941 22.4252C22.5722 22.3477 22.6342 22.2555 22.6765 22.154C22.7188 22.0524 22.7406 21.9435 22.7406 21.8335C22.7406 21.7235 22.7188 21.6146 22.6765 21.513C22.6342 21.4115 22.5722 21.3193 22.4941 21.2418L17.2441 16.0002Z"
                              fill="#677187"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  ref={widgetBtnRef}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    sessionStorage.setItem(
                      `isMinimized-IziChat-${domain}`,
                      `${!isMinimized}`
                    );
                    setIsMinimized(!isMinimized);
                  }}
                >
                  <div
                    className="icon"
                    style={{
                      color: "#fff",
                      backgroundColor: windowProfile.color || "#003434",
                    }}
                  >
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.1109 6.86133C5.7912 6.86133 2.27664 10.0264 2.27664 13.9164C2.27664 15.272 2.7039 16.5848 3.51384 17.7211C3.36017 19.4018 2.95339 20.6475 2.36492 21.2362C2.27332 21.3279 2.25042 21.4677 2.30827 21.5837C2.3598 21.687 2.46496 21.7506 2.57795 21.7506C2.59181 21.7506 2.60597 21.7497 2.62014 21.7476C2.7253 21.7328 5.16084 21.3821 6.93409 20.366C7.93748 20.7677 9.00534 20.9714 10.1112 20.9714C14.4309 20.9714 17.9454 17.8067 17.9454 13.9164C17.9454 10.0261 14.4309 6.86133 10.1109 6.86133Z"
                        fill="white"
                      />
                      <path
                        d="M20.703 14.3176C21.603 13.0546 22.0777 11.5955 22.0777 10.0895C22.0777 5.76661 18.1727 2.25 13.3724 2.25C10.6115 2.25 8.02603 3.45267 6.40015 5.404C7.68753 4.79932 9.14701 4.45512 10.6939 4.45512C15.8632 4.45512 20.0688 8.27207 20.0688 12.9642C20.0688 14.8077 19.4176 16.5147 18.3157 17.9095C19.9717 18.5413 21.6147 18.78 21.696 18.7914C21.7118 18.7934 21.7275 18.7948 21.7429 18.7948C21.8685 18.7948 21.9853 18.7241 22.0426 18.6093C22.1069 18.4804 22.0814 18.325 21.9796 18.2232C21.3254 17.569 20.8734 16.1849 20.703 14.3176Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div
                    className="title"
                    style={{
                      color: "#fff",
                      backgroundColor: windowProfile.color || "#003434",
                      display: windowWidth > 600 ? "flex" : "none",
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        maxWidth: "100%",
                      }}
                    >
                      {content.minimizeHeader || t("widget.let_talk")}
                    </span>
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.34296 1.58358L14.3837 7.34219C14.7396 7.5124 14.8901 7.93887 14.7199 8.29476C14.6495 8.44193 14.5309 8.56057 14.3837 8.63096L2.34296 14.3896C1.98708 14.5598 1.5606 14.4093 1.3904 14.0534C1.31643 13.8987 1.30056 13.7226 1.34566 13.5572L2.54998 9.1413C2.58015 9.03066 2.67354 8.94879 2.78717 8.93336L8.62179 8.14081C8.67207 8.13362 8.71374 8.10058 8.73299 8.05547L8.74301 8.01959C8.75257 7.95264 8.71407 7.88991 8.65368 7.86633L8.62179 7.85796L2.79399 7.06544C2.68038 7.04999 2.58701 6.96812 2.55684 6.8575L1.34566 2.4159C1.24186 2.03531 1.46625 1.64264 1.84684 1.53884C2.01222 1.49374 2.18831 1.50961 2.34296 1.58358Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default WidgetPage;
